import { useEffect, useState } from "react";
import DoubleGroupButtons, {
  IItemDoubleButtonGroup,
} from "../../../ui/button/groupButtons/doubleGroups";
import BaseStep from "./baseStep";
export interface IDataFeatures {
  maternityCapital?: null | boolean;
  encumbrance: null | boolean;
  childrenOwn: null | boolean;
  privatization?: null | boolean;
  arrest?: null | boolean;
  debt?: null | boolean;
}
interface IFeaturesFacilityStep {
  handlePrevStep: () => void;
  handleNexStep: () => void;
  onChange: (data: IDataFeatures) => void;
  isNextStepDisabled: boolean;
  data: IDataFeatures;
  mode?: "default" | "serviceDeal";
}

const FeaturesFacilityStep = ({
  handlePrevStep,
  handleNexStep,
  onChange,
  isNextStepDisabled,
  data,
  mode = "default",
}: IFeaturesFacilityStep) => {
  const [dataFeatures, setDataFeatures] = useState<IDataFeatures>(
    data as IDataFeatures
  );

  const handleChangeDataFeatures = (
    data: boolean,
    key: keyof IDataFeatures
  ) => {
    setDataFeatures((prev) => {
      return { ...prev, [key]: data };
    });
  };

  const handleChange = (data: IDataFeatures) => {
    onChange(data);
  };

  useEffect(() => {
    const hasNill = Object.values(dataFeatures).some((value) => value === null);

    if (!hasNill) {
      handleChange(dataFeatures);
    }
  }, [JSON.stringify(dataFeatures)]);

  const buttonGroups = (function () {
    if (mode === "serviceDeal") {
      return [
        {
          onClick_1: () => handleChangeDataFeatures(true, "maternityCapital"),
          onClick_2: () => handleChangeDataFeatures(false, "maternityCapital"),
          label_1: "Да",
          label_2: "Нет",
          variant_1: dataFeatures.maternityCapital === true ? "dark" : "lightDark",
          variant_2:
            dataFeatures.maternityCapital === false ? "dark" : "lightDark",
          text: "Использование материнского капитала",
        },
        {
          onClick_1: () => handleChangeDataFeatures(true, "encumbrance"),
          onClick_2: () => handleChangeDataFeatures(false, "encumbrance"),
          label_1: "Да",
          label_2: "Нет",
          variant_1: dataFeatures.encumbrance === true ? "dark" : "lightDark",
          variant_2: dataFeatures.encumbrance === false ? "dark" : "lightDark",
          text: "Обременения",
        },
        {
          onClick_1: () => handleChangeDataFeatures(true, "childrenOwn"),
          onClick_2: () => handleChangeDataFeatures(false, "childrenOwn"),
          label_1: "Да",
          label_2: "Нет",
          variant_1: dataFeatures.childrenOwn === true ? "dark" : "lightDark",
          variant_2: dataFeatures.childrenOwn === false ? "dark" : "lightDark",
          text: "Участие не совершеннолетних в сделки",
        },
      ];
    }
    return [
      {
        onClick_1: () => handleChangeDataFeatures(true, "encumbrance"),
        onClick_2: () => handleChangeDataFeatures(false, "encumbrance"),
        label_1: "Да",
        label_2: "Нет",
        variant_1: dataFeatures.encumbrance === true ? "dark" : "lightDark",
        variant_2: dataFeatures.encumbrance === false ? "dark" : "lightDark",
        text: "Обременения",
      },
      {
        onClick_1: () => handleChangeDataFeatures(true, "childrenOwn"),
        onClick_2: () => handleChangeDataFeatures(false, "childrenOwn"),
        label_1: "Да",
        label_2: "Нет",
        variant_1: dataFeatures.childrenOwn === true ? "dark" : "lightDark",
        variant_2: dataFeatures.childrenOwn === false ? "dark" : "lightDark",
        text: "Дети собственики",
      },
      {
        onClick_1: () => handleChangeDataFeatures(true, "privatization"),
        onClick_2: () => handleChangeDataFeatures(false, "privatization"),
        label_1: "Да",
        label_2: "Нет",
        variant_1: dataFeatures.privatization === true ? "dark" : "lightDark",
        variant_2: dataFeatures.privatization === false ? "dark" : "lightDark",
        text: "Приватизация",
      },
      {
        onClick_1: () => handleChangeDataFeatures(true, "debt"),
        onClick_2: () => handleChangeDataFeatures(false, "debt"),
        label_1: "Да",
        label_2: "Нет",
        variant_1: dataFeatures.debt === true ? "dark" : "lightDark",
        variant_2: dataFeatures.debt === false ? "dark" : "lightDark",
        text: "Долги",
      },
      {
        onClick_1: () => handleChangeDataFeatures(true, "arrest"),
        onClick_2: () => handleChangeDataFeatures(false, "arrest"),
        label_1: "Да",
        label_2: "Нет",
        variant_1: dataFeatures.arrest === true ? "dark" : "lightDark",
        variant_2: dataFeatures.arrest === false ? "dark" : "lightDark",
        text: "Аресты",
      },
    ];
  })();

  return (
    <BaseStep
      prevStep={handlePrevStep}
      nextStep={handleNexStep}
      isNextStepDisabled={isNextStepDisabled}
      text="Имеются ли у квартиры:"
    >
      <DoubleGroupButtons data={buttonGroups as IItemDoubleButtonGroup[]} />
    </BaseStep>
  );
};

export default FeaturesFacilityStep;
